// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"683":"32a9b0cb5877462c","828":"e68b81907a741eee"}[chunkId] + ".js";
};